import React from "react"
import {createRoot} from "react-dom/client"
import ajax from "ajax"
import $ from "cash-dom"

function init_sample_quiz(container, max_count, end_screen) {
  const $container = $(container)
  const quiz_id = $container.data("quiz-id")
  const promise = import(
    /* webpackChunkName: "managed_sample_quiz" */
    "components/managed_sample_quiz"
  )
  Promise.all([promise, get_quiz_data(quiz_id)]).then(([module, data]) => {
    createRoot(container).render(
      <module.default
        end_screen={end_screen}
        exercises={data.slice(0, max_count || data.length)}
      />
    )
    $container.removeClass("spinner")
  })
}

function get_quiz_data(quiz_id) {
  return ajax.get(
    `/api/quizzes/${quiz_id}/exercises?locale=${window.gon.locale}&type=sample`
  )
}

export default init_sample_quiz
